// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"selectorItem_wrapper__3Tfe4","isSelected":"selectorItem_isSelected__2sVPV","isLast":"selectorItem_isLast__2EGTM","label":"selectorItem_label__1kHRr"};